<script setup>
import { computed, ref } from 'vue'
import Tooltip from '../Atoms/Tooltip.vue'
import ModalBox from '../modals/ModalBox.vue'
import FormButton from '../Atoms/FormButton.vue'
import IconBase from '../icon/IconBase.vue'
import IconWhatsUp from '../icon/IconWhatsUp.vue'
import IconCheckmark from '../icon/IconCheckmark.vue'
import { openCalendly } from '@/utils'

const props = defineProps({
  plan: {
    type: Object,
  },
  isYearly: {
    type: Boolean
  },
  isCart: {
    type: Boolean
  }
})

const pricingModalOpen = ref(false)

const openPricingModal = () => {
  pricingModalOpen.value = true
}

const closePricingModal = () => {
  pricingModalOpen.value = false
}

const visibleCharacteristics = computed(() =>
  props.plan.charectiristics?.filter(item => props.isYearly || !item.yearlyOnly) ?? []
)
</script>

<template>
  <ul class="!p-4 text-sm flex flex-col gap-y-2.5 bg-surface-2 text-surface-9 rounded-b-xl">
    <li v-for="(item, index) in visibleCharacteristics" :key="index" :class="{ 'text-white font-semibold': item.accent }">
      <Tooltip :content="item.details" :disabled="!item.details">
        <div v-if="item.divider" class="h-1" aria-hidden="true"></div>
        <div v-else class="flex items-start gap-2 rounded-md" :class="{ 'bg-main-transparent -mx-1.5 px-1.5 py-1': item.accent }">
          <figure v-if="item.accent" class="shrink-0 mt-0.5 bg-main flex items-center justify-center size-4 rounded-full">
            <icon-base classIcon="text-white" width="11" height="11" fill="none">
              <IconCheckmark />
            </icon-base>
          </figure>
          <icon-base v-else class="shrink-0 mt-0.5 text-success" width="16" height="16" fill="none">
            <IconCheckmark />
          </icon-base>
          <span class="flex-1">
            <span class="capitalize" v-html="isYearly ? item.name : (item.monthly || item.name)" />
            <FormButton
              v-if="item.pricingAction === 'ott-addons'"
              type="link"
              size="sm"
              customClasses="!p-0 !ml-1 inline text-main hover:text-main-light"
              @click="openPricingModal"
            >
              Contact Us &gt;
            </FormButton>
            <span v-if="item.hasQuestionmark" class="inline-flex size-4 bg-surface-6 text-white text-xs rounded-full items-center justify-center !ml-1">?</span>
          </span>
        </div>
      </Tooltip>
    </li>
  </ul>

  <ModalBox
    v-model="pricingModalOpen"
    title="Contact us to get detailed pricing for OTT app add-ons"
    size="sm"
    @close="closePricingModal"
  >
    <div class="p-6 flex flex-col gap-3">
      <FormButton
        full-width
        size="lg"
        label="Book a Meeting"
        class="justify-center"
        @click="openCalendly(); closePricingModal()"
      />
      <FormButton
        full-width
        size="lg"
        href="https://wa.me/16049988035"
        target="_blank"
        customClasses="!border !border-success inline-flex items-center justify-center !rounded-md text-nowrap box-border font-medium hover:no-underline max-w-full py-2 !px-3 h-10 text-base bg-transparent hover:!border-success-light !text-success hover:!text-success-light w-full"
        @click="closePricingModal"
      >
        Chat with us via WhatsApp
        <IconBase classIcon="ml-2" fill="none">
          <IconWhatsUp />
        </IconBase>
      </FormButton>
    </div>
  </ModalBox>
</template>

<style>
</style>
